import { env } from "@/env.mjs";
import { BuilderContent } from "@builder.io/sdk";
import { GetContentOptions } from "@builder.io/sdk/dist/src/builder.class";

export default class BuilderUtils {
  static createBaseContentOptions(locale: string | undefined, options: GetContentOptions): GetContentOptions {
    options = {
      locale: locale,
      prerender: false,
      cachebust: env.NEXT_PUBLIC_BUILDER_DISABLE_CACHE,
      cache: !env.NEXT_PUBLIC_BUILDER_DISABLE_CACHE,
      includeUnpublished: env.NEXT_PUBLIC_BUILDER_INCLUDE_UNPUBLISHED,
      ...options,
    };

    // works around a bug in the builder.io SDK that adds the limit and offset as
    // "options.(modelname).(someid).limit|offset" which does not seem to work.
    if (options.limit !== undefined) {
      options.options = {
        ...options.options,
        limit: options.limit,
      };
    }
    if (options.offset !== undefined) {
      options.options = {
        ...options.options,
        offset: options.offset,
      };
    }

    return options;
  }

  static async loadAllEntries<T extends BuilderContent>(
    loadEntriesFunc: (page: number, pageCount: number) => Promise<T[]>,
    pageCount: number = 100,
  ): Promise<T[]> {
    let page = 1;
    let entries: T[] = [];

    let newEntries: T[] = [];
    do {
      newEntries = await loadEntriesFunc(page, pageCount);
      entries.push(...newEntries);
      page++;
    } while (newEntries.length == pageCount);

    return entries;
  }

  static async loadAllEntriesData<T>(
    loadEntriesFunc: (page: number, pageCount: number) => Promise<BuilderContent[]>,
    pageCount: number = 100,
  ): Promise<T[]> {
    const entries = await BuilderUtils.loadAllEntries(loadEntriesFunc, pageCount);

    return entries.map((entry) => entry.data) as T[];
  }
}
